import { EmployeeAbsenceTypeModelType } from '@teinor/erp/types/company/userInner/employee/employeeAbsence/employeeAbsenceType'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalCEEmployeeAbsenceTypeProps extends ModalEditComponentProps {}

const ModalCEEmployeeAbsenceType: React.FC<ModalCEEmployeeAbsenceTypeProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<EmployeeAbsenceTypeModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'justified',
                    label: t('absenceJustified', 'Ausencia justificada'),
                    component: 'CheckboxMargin',
                    tooltip: t('absenceJustifiedTooltip','Las ausencias justificadas son aquellas que no hace falta recuperar las horas. No marques este recuadro si tus empleados deben recuperar las horas con este tipo de ausencia.')
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/workingCalendar/employeeAbsence/updateEmployeeAbsenceType'} translations={{ title: t('editEmployeeAbsenceType', 'Editar tipo de ausencia'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest}></LittleModalCreateEdit>)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/workingCalendar/employeeAbsence/createEmployeeAbsenceType'} translations={{
        title: t('createEmployeeAbsencetype', 'Crear tipo de ausencia'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEEmployeeAbsenceType